import styles from "./portfolio.module.scss";
import { Routes, Route } from "react-router-dom";
import AboutMe from "./AboutMe";
import FacebookAutoPost from "./FacebookAutoPost";

const PortfolioPages = () => {
    return (
        <div
            id={styles.root}
            style={{
                backgroundImage: "url('/background.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundAttachment: "fixed",
                minHeight: "100vh",
                overflow: "hidden",
                width: "100%",
            }}
        >
            <Routes>
                <Route path="/facebook-auto-post" element={<FacebookAutoPost />} />
                <Route path="/*" element={<AboutMe />} />
            </Routes>
        </div>
    );
};

export default PortfolioPages;